const navigateToLogin = () => {
    window.location.href = "/login";
}

export const get = async (path) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        headers: {
            "Token": localStorage.getItem("token"),
        },
    });
    if (response.status === 401) {
        navigateToLogin();
        return;
    }
    return response.json();
}

export const post = async (path, data) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Token": localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
    });
    if (response.status === 401) {
        navigateToLogin();
        return;
    }
    return response.json();
}